import React from 'react';
import { withStyles } from '@material-ui/core';
import LoadingAni from "../../asset/img/loading.json";
import IntroAni from "../../asset/img/animation_intro.json";
import Lottie from "lottie-react";

const styles = () => ({
  body: {
    /*
    position: "absolute",
    margin: "auto",
    top: "0",
    left: "0",
    bottom: "0",
    right: "0",
    width: "50%",
    height: "50%"
    */
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "var(--height)",//"100vh",
    // backgroundColor: "#ddd"
  },
  introAnimation: {
    width: "12.5rem",
    height: "12.5em",
    cursor: "pointer",
  },
  loadingAnimation: {
    width: "5rem",
    height: "2.5rem",
    cursor: "pointer"
  }
});

function Loading(props) {
  const { classes, callbackFunc, isLoadingComplete, height="100vh" } = props;
  const introOpt = {
    loop: false,
    animationData: IntroAni
  }
  const loadingOpt = {
    loop: true,
    animationData: LoadingAni
  }
  const animationOpt = {
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  return (
    <>
      <div className={classes.body}  style={{"--height":height}}>
        {isLoadingComplete===false? (
          <Lottie
            {...animationOpt}
            {...introOpt}
            className={classes.introAnimation}
            onComplete={() => {
              callbackFunc();
              console.log("Intro complete");
            }}
            width={"12.5rem"}
            height={"12.5rem"}
          />
        ) : (
          <Lottie
            {...animationOpt}
            {...loadingOpt}
            className={classes.loadingAnimation}
            width={"5rem"}
            height={"2.5rem"}
          />
        )}
      </div>
    </>
  );
}
export default withStyles(styles)(Loading);